module.exports = "/static/media/glyphicons-halflings-regular.448c34a5.woff2";